/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Benefit_Teams_RolesInputs */



/**
* | output |
* | --- |
* | "Create unlimited teams with custom roles" |
*
* @param {Plan_Gate_Benefit_Teams_RolesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_benefit_teams_roles = /** @type {((inputs?: Plan_Gate_Benefit_Teams_RolesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Benefit_Teams_RolesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unbegrenzte Teams mit benutzerdefinierten Rollen erstellen")
	return /** @type {LocalizedString} */ ("Create unlimited teams with custom roles")
});